import isArray from 'lodash/isArray';
import React from 'react';

interface IProps {
  children: JSX.Element | JSX.Element[];
  defaultKey?: number | string;
  rootClassName?: string;
  activeClassName?: string;
  inactiveClassName?: string;
  expandKeys?: number[] | string[];
}

const Accordion: React.FC<IProps> = ({ children, defaultKey, rootClassName = '', activeClassName = '', inactiveClassName = '', expandKeys = [] }) => {
  return (
    <div
      id='accordion-flush'
      data-accordion='collapse'
      data-active-classes={`bg-white ${activeClassName}`}
      data-inactive-classes={`text-hl-gray-x11 ${inactiveClassName}`}
      className={`space-y-6 ${rootClassName}`}
    >
      {isArray(children)
        ? children.map((child, index) => {
            const accordionKey = `accordion-key-${index}`;

            return React.cloneElement(child, {
              key: accordionKey,
              defaultKey: defaultKey,
              expandKeys: expandKeys,
              ...child.props
            });
          })
        : React.cloneElement(children, { defaultKey: defaultKey, ...children.props })}
    </div>
  );
};

export default Accordion;
